import { baseApi } from '@/store/baseApi';

import type {
  LegalDocumentCurrentResponse,
  LegalTermsAcceptPayload,
  LegalTermsAcceptResponse,
  LegalTermsCurrentResponse,
} from '@/features/legal/types';
import type { APIResponse } from '@web/types';

export const legalApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentTerms: builder.query<
      APIResponse<LegalTermsCurrentResponse>,
      void
    >({
      query: () => ({
        url: 'legal/terms/current',
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
      providesTags: [{ type: 'CurrentTerms', id: 'CURRENT' }],
    }),
    getCurrentPrivacy: builder.query<
      APIResponse<LegalDocumentCurrentResponse>,
      void
    >({
      query: () => ({
        url: 'legal/privacy/current',
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    getCurrentDpa: builder.query<
      APIResponse<LegalDocumentCurrentResponse>,
      void
    >({
      query: () => ({
        url: 'legal/dpa/current',
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    acceptCurrentTerms: builder.mutation<
      APIResponse<LegalTermsAcceptResponse>,
      LegalTermsAcceptPayload
    >({
      query: (body) => ({
        url: 'legal/terms/accept',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'CurrentTerms', id: 'CURRENT' }],
    }),
  }),
});

export const {
  useGetCurrentTermsQuery,
  useGetCurrentPrivacyQuery,
  useGetCurrentDpaQuery,
  useAcceptCurrentTermsMutation,
} = legalApi;
